import type { CSSProperties } from 'react';
import { Icon } from './Icon';

export interface SetaDeRolagemProps {
    lado: 'antes' | 'depois';
    onClick: () => void;
    /** Posição vertical. No meio por padrão; o quadro a sobe para a altura dos cabeçalhos. */
    topo?: number | string;
    style?: CSSProperties;
}

/**
 * A seta ‹ › na borda de um contêiner que rola de lado.
 *
 * Só para mouse: fica fora da ordem de tabulação e da árvore de acessibilidade
 * porque quem usa teclado rola pelo próprio conteúdo (setas entre abas, Tab
 * entre linhas), e um botão a mais por borda seria ruído para quem ouve.
 */
export function SetaDeRolagem({ lado, onClick, topo = '50%', style }: SetaDeRolagemProps) {
    return (
        <button
            type="button" tabIndex={-1} aria-hidden="true" onClick={onClick}
            title={lado === 'antes' ? 'Ver anteriores' : 'Ver mais'}
            style={{
                position: 'absolute', top: topo, [lado === 'antes' ? 'left' : 'right']: 0, transform: 'translateY(-50%)', zIndex: 2,
                width: 26, height: 26, padding: 0, borderRadius: '50%', border: '1px solid var(--border)',
                background: 'var(--surface)', color: 'var(--neutral-600)', cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'var(--transition-control)',
                ...style,
            }}
        >
            <Icon name={lado === 'antes' ? 'chevron-left' : 'chevron-right'} size={15} />
        </button>
    );
}
